<template>

  <div class="main">

 
  <el-row style="margin-top: 40px;" type="flex" justify="center" class="top">
    <el-col :xs="24" :sm="18" class="flex">
      <el-row type="flex" justify="center">
        <el-col :xs="7" :sm="4" class=" left">
          <el-select v-model="inputValue" placeholder="对接活动">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="11" :sm="14" class="padding center">
          <input type="text" placeholder="请输入查询内容" />
        </el-col>
        <el-col :xs="6" :sm="6" class="padding right" > 
          <div class="jumpPath" @click="jumpPath">
            查询
          </div>
       </el-col>
      </el-row>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      options: [
        {
          value: '1',
          label: '对接活动'
        }, {
          value: '2',
          label: '项目详情'
        }, {
          value: '3',
          label: '投资机构'
        }, 
        ],
        inputValue: ''
    };
  },
  created: function () {},
  methods: {
    //跳转路径
    jumpPath(){
      console.log(11111);
      console.log(this.inputValue);
      switch (this.inputValue) {
        case '1':
          window.location.href=window.location.origin+"/SearchCloudDocking";//搜索云对接
          break;
        case '2':
          window.location.href=window.location.origin+"/SearchProject";//搜索项目详情
          
          break;
        case '3':
          window.location.href=window.location.origin+"/VentureCapitalFirm";//搜索投资机构
          
          break;
        default:
          break;
      }
    }

  },
  watch:{
  
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .top .left img {
  left: 2px;
  }
  .top .center input{
    margin-left: 15px;
  }
}
.top{
  margin-left: 5px;
  margin-right: 5px;

}
.padding {
  padding: 20px 0;
}
.flex {
  /* display: flex;
    justify-content: center; */
}
.left {
  /* width: 118px; */
  padding-top: 12px;
  background-color: #ffffff;
  border-radius: 8px 0px 0px 8px;
  border: solid 1px #dadada;
  text-align: center;
  
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #999999;
  position: relative;
}
.left .el-input__inner{
  outline: none !important;
  border: none !important;
}
.left img {
  position: relative;
  top: 2px;
  left: 5px;
}
.center {
  /* width: 679px; */
  background-color: #ffffff;
  border: solid 1px #dadada;
  border-left: none;
  text-align: left;

  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
}
.center input {
  margin-left: 15px;
  outline: none;
  border: none;
}
.right {
  /* width: 149px; */
  text-align: center;
  background-color: #f957fd;
  border-radius: 0px 8px 8px 0px;

  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

/*修改提示文字的颜色*/

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b7b7b7 !important;
}

input::-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #b7b7b7 !important;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b7b7b7 !important;
}
input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #b7b7b7 !important;
}
.jumpPath{
  cursor: pointer;
}
</style>
<style>
.el-input__inner{
  outline: none !important;
  border: none !important;
}
</style>